import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { utils, writeFileXLSX } from "xlsx";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import MonthPicker from "simple-react-month-picker";
import { MultiSelect } from "react-multi-select-component";
import ReactPaginate from 'react-paginate';

import CheckboxTable from "fragments/CheckboxTable";
import DownloadExcel from 'utils/DownloadExcel';

import Button from "react-bootstrap/Button";
import useToken from "utils/UseToken";
import { useRecoilValue } from "recoil";

import pos2 from "../../img/pos2.png";
import { MoonLoader } from "react-spinners";
import {
  getCurrentDate,
  convertDateFormat,
  getCurrentDateM,
  formatDateToYMD,
  subtractDays,
  getCurrentDateforApi,
} from "utils/dateFormat";
import Select from "react-select";
import { default as ReactSelect, components, InputAction } from "react-select";





export function ReportMonthlySales() {
  const { token, setToken } = useToken();
  let { businessId } = useParams();
  const navigate = useNavigate();

  const [business, setBusiness] = useState(businessId);
  const [reportdata, setreportdata] = useState([]);
  const [searchdata, setSearchdata] = useState({
    branchID: "",
    posID: "",
    startDate: getCurrentDateforApi("-"),
    endDate: getCurrentDateforApi("-"),
  });


  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showResetSearch, setShowResetSearch] = useState(false);
  const [pos, setPos] = useState([]);
  const [dateApplied, setDateApplied] = useState(false);
  const currentDate = new Date();
  const endDate = getCurrentDateforApi("-", currentDate);
  const startDate = getCurrentDateforApi("-", subtractDays(currentDate, 7));
  const [fetchDate, setCurrentDate] = useState({ startDate, endDate });
  const [optionsBranch, setOptionsBranch] = useState([]);
  const [optionsPos, setOptionsPos] = useState([]);
  const keyRef = useRef();


  const columns = [
    {
      name: 'เดือน',
      selector: row => row.month,
    },
    {
      name: 'ยอดรวม',
      selector: row => row.amount,
    },
    {
      name: (
        <div className="lh-sm">
          <div>ส่วนลด</div>
          <div>ITEM</div>
        </div>
      ),
      selector: row => row.discount_item,
      center: 'true',
    },
    {
      name: (
        <div className="lh-sm">
          <div>ส่วนลด</div>
          <div>ท้ายบิล</div>
        </div>
      ),
      selector: row => row.discount_end_bill,
      center: 'true',
    },
    {
      name: (
        <div className="lh-sm">
          <div>ส่วนลด</div>
          <div>คะแนน</div>
        </div>
      ),
      selector: row => row.discount_point,
      center: 'true',
    },
    {
      name: 'ยอดสุทธิ',
      selector: row => row.net_amount,
      center: 'true',
      cell: (row, index, column, id) => <div style={{ color: "#2DC76D", fontWeight: 700 }}>{row.net_amount}</div>,
    },
    {
      name: (
        <div className="lh-sm">
          <div>มูลค่าสินค้า</div>
          <div className="fs-10 text-center pt-1">ไม่มีภาษี</div>
        </div>
      ),
      selector: row => row.product_price_no_tax,
      center: 'true',
    },
    {
      name: (
        <div className="lh-sm">
          <div>มูลค่าสินค้า</div>
          <div className="fs-10 text-center pt-1">มีภาษี</div>
        </div>
      ),
      selector: row => row.product_price_tax,
      center: 'true',
    },
    {
      name: 'ภาษีมูลค่าเพิ่ม',

      selector: row => row.vat,
      center: 'true',
      width: '120px'
    },
    {
      name: 'จำนวนบิล',
      selector: row => row.bills,
      center: 'true',
    },
    {
      name: (
        <div className="lh-sm">
          <div>จำนวนบิล</div>
          <div className="fs-10 text-center pt-1">ที่ยกเลิก</div>
        </div>
      ),
      selector: row => row.bills_canceled,
      center: 'true',
    },
    {
      name: (
        <div className="lh-sm tc-14">
          <div>จำนวนบิล</div>
          <div className="fs-10 text-center pt-1">การคืนสินค้า</div>
        </div>
      ),
      selector: row => row.bills_return,
      center: 'true',
      cell: (row, index, column, id) => <div style={{ color: "#FF0000" }}>{row.bills_return}</div>,
    },
    {
      name: (
        <div className="lh-sm tc-14">
          <div>มูลค่าสินค้า</div>
          <div className="fs-10 text-center pt-1">การคืนสินค้า</div>
        </div>
      ),
      selector: row => row.product_return,
      center: 'true',
      cell: (row, index, column, id) => <div style={{ color: "#FF0000" }}>{row.product_return}</div>,
    },

  ]


  const customStyles = {
    rows: {
      style: {
        minHeight: "52px",
      },
    },
    headCells: {
      style: {
        paddingLeft: "15px",
        paddingRight: "15px",
        color: "rgba(76, 78, 100, 0.87)",
        fontFamily: "Sarabun",
        fontSize: "14px",
        background: " #F5F5F7",
        paddingTop: "5px",
        paddingBottom: "5px",
        fontWeight: "500",
      },
    },
    cells: {
      style: {
        paddingLeft: "15px",
        paddingRight: "15px",
        color: "rgba(76, 78, 100, 0.87)",
        fontFamily: "Sarabun",
        background: " #FFF",
        fontSize: "14px",
        fontWeight: "300",
      },
    },
    expanderRow: {
      style: {
        minHeight: "52px",
      },
    },
    pagination: {
      style: {
        borderBottomRightRadius: "0.75rem",
        borderBottomLeftRadius: "0.75rem",
      },
    },
  };


  const paginationComponentOptions = {
    rowsPerPageText: "จำนวนรายการต่อหน้า",
    rangeSeparatorText: "of",
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  };



  const handleSearch = () => {
    setIsLoading(true);
    let formattedStartDate = searchdata.startDate;
    let formattedEndDate = searchdata.endDate;



    setShowResetSearch(true);
    setreportdata([
      {
        "month": "JAN/2024",
        "amount": "100,000.00",
        "discount_item": "0.00",
        "discount_end_bill": "50,000.00",
        "discount_point": "0.00",
        "net_amount": "50,000.00",
        "product_price_no_tax": "20,000.00",
        "product_price_tax": "28,037.38",
        "vat": "1,962.62",
        "bills": "50",
        "bills_canceled": "50",
        "bills_return": "0",
        "product_return": "0",
      },
      {
        "month": "Feb/2024",
        "amount": "100,000.00",
        "discount_item": "0.00",
        "discount_end_bill": "50,000.00",
        "discount_point": "0.00",
        "net_amount": "50,000.00",
        "product_price_no_tax": "20,000.00",
        "product_price_tax": "28,037.38",
        "vat": "1,962.62",
        "bills": "50",
        "bills_canceled": "50",
        "bills_return": "0",
        "product_return": "0",
      }
    ]);
    setIsLoading(false);
  };
  const resetFilter = () => {
    setShowResetSearch(false);
    setreportdata([]);

  };






  const handlerSelectBranchChange = (e) => {
    // check if e is not null
    if (e) {
      if (e.label != "ทั้งหมด") {
        setSearchdata((prev) => ({ ...prev, branchID: e.value }));
      } else {
        setSearchdata((prev) => ({ ...prev, branchID: "", posID: "" }));
      }
    }
  };


  const [filterText, setFilterText] = useState("");

  let filteredItems;
  if (reportdata !== undefined && reportdata.length > 0) {
    filteredItems = reportdata.filter((item) => {
      const matchCode = item.month
        .toLowerCase()
        .includes(filterText.toLowerCase());
      return matchCode;
    });
  }

  return (
    <div>

      <nav aria-label="breadcrumb" className="mt-2">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item ">
            <a href="#" className="tc-7  text-decoration-none">
              รายงาน
            </a>
          </li>
          <li className="breadcrumb-item active tc-1 " aria-current="page">
            {" "}
            ยอดขายรายเดือน{" "}
          </li>
        </ol>
      </nav>

      <div className="card card-st-2 mb-4">
        <div className="card-body  py-4">
          <div className="fw-bold mb-3">ค้นหาขั้นสูง</div>
          <div className="row items-center">
            <div className="col-xl-2 col-lg-3 col-2">
              <Select
                as="select"
                name="branch"
                onChange={(e) => handlerSelectBranchChange(e)}
                className={`w-100 select-st-1 sm pd`}
                options={optionsBranch}
                placeholder="เลือกสาขา"
                isClearable={true}
              />
            </div>

            <div className="col-xl-3 col-lg-3 col-2">
              <MonthPicker
                onChange={(range) => {
                  setSearchdata((prev) => ({
                    ...prev,
                    startDate: range[0],
                    endDate: range[1]
                  }))

                }}
                value={[searchdata.startDate, searchdata.endDate]}
                style={{ height: '40px', borderColor: '#ccc' }}
              />
            </div>
            <div className="col-auto">
              <Button
                type="button"
                className="btn-st-3 flex justify-center items-center"
                style={{ width: "120px", height: "40px" }}
                onClick={handleSearch}
              >
                ค้นหา
              </Button>
            </div>
            {showResetSearch && (
              <div className="col-auto">
                <Button
                  type="button"
                  className="bg-orange-400 flex justify-center items-center hover:bg-orange-300"
                  style={{ width: "150px", height: "40px", border: 0 }}
                  onClick={resetFilter}
                >
                  ล้างการค้นหา
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="w-full h-screen flex justify-center items-start">
          <MoonLoader
            color="#565DFF"
            loading={isLoading}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
            className="mt-40"
          />
        </div>
      )}
      {showResetSearch && (
        <div className="card card-st-2">
          <div className="card-body p-0 rounded-xl">
            <div className="d-flex align-items-center px-4 mb-4 pt-4 rd-0">
              <DownloadExcel data={filteredItems} filename="ยอดขายรายเดือน" />
              <div>
                <input
                  type="text"
                  className="form-control form-st-4"
                  placeholder="ค้นหา"
                  onKeyUp={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
            <DataTable
              columns={columns}
              data={filteredItems}
              customStyles={customStyles}
              selectableRows
              selectableRowsComponent={CheckboxTable}
              pagination
              paginationComponent={(props) => (
                <CustomPagination
                  rowCount={props.rowCount}
                  rowsPerPage={10}
                  currentPage={props.currentPage}
                  onChangePage={(page) => props.onChangePage(page, props.rowCount)}
                  onChangeRowsPerPage={(currentRowsperPage, currentPage) =>
                    props.onChangeRowsPerPage(currentRowsperPage, currentPage)}
                  data={filteredItems}
                />
              )
              }
            />
          </div>
          <div className="py-3"></div>
        </div>
      )}
    </div>
  );
}


const CustomPagination = ({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage, data }) => {
  const count = rowCount / rowsPerPage;

  const handleRowsPerPage = React.useCallback(
    e => onChangeRowsPerPage(Number(e.target.value), currentPage),
    [currentPage, onChangeRowsPerPage]
  )

  return (
    <>
      <div className=' d-flex align-items-center justify-content-end mx-0 pt-3' style={{ borderTop: '1px solid #e0e0e0' }}>

        <div className='  fs-12 d-flex justify-content-start  me-5' style={{ color: '#4C4E64' }}>
          <p>
            <span className="me-4">
              จำนวนรายการต่อหน้า  <span className="ms-2"></span>{' '}

              <select onChange={handleRowsPerPage}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
              </select>
            </span>
            {currentPage * rowsPerPage + 1 - rowsPerPage}
            <span className="mx-1 fs-18">-</span>
            {currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage}
            <span className="mx-1">of</span> {rowCount}
          </p>
        </div>

        <div className=' d-flex justify-content-end'>
          <ReactPaginate
            previousLabel={<i class="icon-prev"></i>}
            nextLabel={<i class="icon-next"></i>}
            forcePage={currentPage !== 0 ? currentPage - 1 : 0}
            onPageChange={page => {

              onChangePage(page.selected + 1, rowCount)

            }}
            pageCount={count || 1}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName='page-item'
            breakLinkClassName='page-link'
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pr-1 mt-1'}
          />
        </div>
      </div>
    </>
  )
}